import Dropdown from 'react-bootstrap/Dropdown';
import Col from 'react-bootstrap/esm/Col';
import { useState } from 'react';

function NavigationSection() {
  const [currentSection, setCurrentSection] = useState('');
  return (
    <>
      <Dropdown className='mt-4 d-md-none sticky-top' size='sm'>
        <Dropdown.Toggle
          id='dropdown-basic'
          className='w-100 border bg-white text-black'
          size='sm'
        >
          Navigera i inbjudan
        </Dropdown.Toggle>

        <Dropdown.Menu className='w-100'>
          <Dropdown.Header>Navigera i inbjudan</Dropdown.Header>

          <Dropdown.Item href='#section-general-information'>
            Grundinformation
          </Dropdown.Item>
          <Dropdown.Item href='#section-implementation'>
            Genomförande & bestämmelser
          </Dropdown.Item>
          <Dropdown.Item href='#section-officers'>Funktionärer</Dropdown.Item>
          <Dropdown.Item href='#section-contact-info'>
            Kontaktuppgifter
          </Dropdown.Item>
          <Dropdown.Item href='#section-other-info'>
            Övrig information
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Col md={3} xxl={2}>
        <ul className='list-unstyled d-none d-md-flex flex-column gap-2 position-sticky top-0 pt-4'>
          <li className='fw-bold'>Navigera i inbjudan</li>
          <li role='button' className='hover-opacity'>
            <a
              href='#section-general-information'
              className={`text-reset text-decoration-none ${
                currentSection === 'general' ? 'text-decoration-underline' : ''
              }`}
            >
              Grundinformation
            </a>
          </li>
          <li role='button' className='hover-opacity'>
            <a
              href='#section-implementation'
              className={`text-reset text-decoration-none ${
                currentSection === 'implementation'
                  ? 'text-decoration-underline'
                  : ''
              }`}
            >
              Genomförande & bestämmelser
            </a>
          </li>
          <li role='button' className='hover-opacity'>
            <a
              href='#section-officers'
              className={`text-reset text-decoration-none ${
                currentSection === 'officers' ? 'text-decoration-underline' : ''
              }`}
            >
              Funktionärer
            </a>
          </li>
          <li role='button' className='hover-opacity'>
            <a
              href='#section-contact-info'
              className={`text-reset text-decoration-none ${
                currentSection === 'contact' ? 'text-decoration-underline' : ''
              }`}
            >
              Kontaktuppgifter
            </a>
          </li>
          <li role='button' className='hover-opacity'>
            <a
              href='#section-other-info'
              className={`text-reset text-decoration-none ${
                currentSection === 'other' ? 'text-decoration-underline' : ''
              }`}
            >
              Övrig information
            </a>
          </li>
        </ul>
      </Col>
    </>
  );
}

export default NavigationSection;
